import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "../../Global/Scroll";
import { errorMessages } from "../../../Constants/Errors";
import { blog_page_labels } from "../../../Constants/Labels";
import { callAPI, useStore, usePage, useUser } from "../../../Utils/utils";
import {
  item_required_error_message,
  alert_message_type,
} from "../../../Constants/Messages";
import Alert from "../../Alert/Alert";
import Message from "../../Message/Message";
import BlogImageSelector from "../../ImageSelector/BlogImageSelector";
import BlogImagesPreview from "../../ImagesPreview/BlogImagesPreview";
import ErrorMessage from "../../Global/ErrorMessage";
import "./BlogAdd.css";
import "./BlogContentEditor.css";
import "./DragDrop.css";
import TextBlock from "./TextBlock";
import ImageBlock from "./ImageBlock";
import QuoteBlock from "./QuoteBlock";
import { set } from "react-hook-form";

export default function BlogAdd() {
  const navigate = useNavigate();
  const { store } = useStore();
  const { setPage } = usePage();
  const { user } = useUser();
  const [alert, setAlert] = useState();
  const [config, setConfig] = useState();
  const [errors, setErrors] = useState();
  const [loading, setLoading] = useState(false);
  const [formValues, setformValues] = useState({});
  const [selectedImages, setSelectedImages] = useState({});
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [categories, setCategories] = useState([]);
  const [contentBlocks, setContentBlocks] = useState([]);
  const [nextBlockId, setNextBlockId] = useState(1);
  const [focusBlockIndex, setFocusBlockIndex] = useState(null);
  const [showBlockOptions, setShowBlockOptions] = useState(false);
  const [imageSelectionContext, setImageSelectionContext] = useState(-1);

  useEffect(() => {
    setPage({ isLoading: loading });
  }, [loading]);

  useEffect(() => {
    if (store?.id) {
      callAPI(
        "/admin/blog-categories/by-store",
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            token: user?.auth_token,
          },
          body: JSON.stringify({
            store_id: store?.id,
            status: "active",
            page_size: 100,
            current_page: 1,
          }),
        },
        navigate,
        setLoading,
      ).then((data) => {
        if (data.success) {
          setCategories(data.records);
        }
      });
    }
  }, [store?.id]);

  const createBlog = () => {
    setLoading(true);
    scrollToTop();

    // Validate mandatory fields
    const validationErrors = {};
    
    if (!formValues?.title?.trim()) {
      validationErrors.title = "Title is required";
    }
    
    if (!formValues?.sub_title?.trim()) {
      validationErrors.sub_title = "Subtitle is required";
    }
    
    if (!formValues?.blog_category_id) {
      validationErrors.blog_category_id = "Category is required";
    }
    
    if (!formValues?.status) {
      validationErrors.status = "Status is required";
    }
    
    if (!selectedImages?.blog_image_id) {
      validationErrors.featured_image = "Featured image is required";
    }

    if (contentBlocks.length === 0) {
      validationErrors.content = "Content is required";
    }

    // If there are validation errors, show them and stop
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      setShowErrorMessage(true);
      setLoading(false);
      scrollToTop();
      return;
    }

    // Clear any previous errors
    setErrors({});
    setShowErrorMessage(false);

    // Process content blocks to ensure proper structure
    const processedContentBlocks = contentBlocks.map((block) => {
      if (
        block.type === "image" &&
        typeof block.content === "object" &&
        block.content?.blog_image_id
      ) {
        return {
          ...block,
          content: block.content,
        };
      }
      return block;
    });

    var pay_load = {
      store_id: store?.id,
      title: formValues?.title?.trim(),
      sub_title: formValues?.sub_title?.trim() || null,
      content: JSON.stringify(processedContentBlocks),
      blog_category_id: formValues.blog_category_id || null,
      status: formValues.status ? formValues.status : "inactive",
      featured_image: selectedImages?.blog_image_id
        ? selectedImages?.blog_image_id
        : null,
    };

    console.log("validationErrors",validationErrors);
    

    callAPI(
      "/admin/blog/create",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          token: user?.auth_token,
        },
        body: JSON.stringify(pay_load),
      },
      navigate,
      setLoading,
    ).then((data) => {
      if (data.success === true) {
        var id = data?.blog_id || data?.id;
        navigate(`/admin/blog/edit/${id}`);
        localStorage.setItem("Message", "Blog created successfully");
        setLoading(false);
      } else {
        setLoading(false);
        setShowErrorMessage(true);
        setErrors(data?.errors);
        setAlert({
          text: item_required_error_message,
          type: alert_message_type?.error,
        });
      }
    });
  };

  const onChangeField = (event) => {
    const { name, value, type, checked } = event.target;
    const fieldValue = type === "checkbox" ? checked : value;
    setformValues({ ...formValues, [name]: fieldValue });
    setShowErrorMessage(false);
    setErrors([]);
  };

  const onOpenFeaturedImage = (configData) => {
    setImageSelectionContext(-1);
    setConfig(configData);
  };

  const onOpenContentBlockImage = (configData, blockIndex) => {
    setImageSelectionContext(blockIndex);
    setConfig(configData);
  };

  const onClose = () => {
    setConfig(false);
    setImageSelectionContext(-1);
  };

  console.log("imageSelectionContext", imageSelectionContext, selectedImages);
  

  const onSelectImages = (images) => {
    console.log("imageSelectionContext123",imageSelectionContext,imageSelectionContext >=0,images);
    
    if (imageSelectionContext >=0) {
      updateContentBlock(imageSelectionContext, images);
      // setImageSelectionContext(-1);
    }else {
      console.log("selected image", images);
      // This is for featured image selection
      setSelectedImages(images);
    }
  };

  const onRemoveImageIds = () => {
    setSelectedImages(null);
  };

 const addContentBlock = (type) => {
    setContentBlocks((prevBlocks) => {
      const newBlocks = [
        ...prevBlocks,
        {
          type: type,
          content: type === "text" ? "" : type === "quote" ? "" : null,
        },
      ];

      // focus last block
      setFocusBlockIndex(newBlocks.length - 1);

      return newBlocks;
    });
  };

  const removeContentBlock = (blockId) => {
    setContentBlocks((prevBlocks) => {
      // if (prevBlocks.length > 1) {
      return prevBlocks.filter((block, index) => index !== blockId);
      // }
      // return prevBlocks;
    });
  };

  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("text/plain", index);
    e.target.style.opacity = "0.5";
  };

  const handleDragEnd = (e) => {
    e.target.style.opacity = "";
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "#f8f9fa";
  };

  const handleDragLeave = (e) => {
    e.currentTarget.style.backgroundColor = "";
  };

  const handleDrop = (e, dropIndex) => {
    e.preventDefault();
    e.currentTarget.style.backgroundColor = "";

    const dragIndex = parseInt(e.dataTransfer.getData("text/plain"));

    if (dragIndex === dropIndex) return;

    const draggedBlock = contentBlocks[dragIndex];
    const newBlocks = [...contentBlocks];

    // Remove dragged block from its original position
    newBlocks.splice(dragIndex, 1);

    // Insert dragged block at the new position
    newBlocks.splice(dropIndex, 0, draggedBlock);

    setContentBlocks(newBlocks);
  };

  const 
  updateContentBlock = (blockId, content) => {
    setContentBlocks((prevBlocks) =>
      prevBlocks.map((block, index) =>
        index === blockId ? { ...block, content } : block,
      ),
    );
  };

  const statusOptions = Object.keys(
    blog_page_labels?.blog_add_and_edit_page_status,
  )?.map((name) => {
    const value = blog_page_labels?.blog_add_and_edit_page_status[name];
    return `${name},${value}`;
  });

  console.log("contents", contentBlocks, formValues);

  return (
    <React.Fragment>
      {alert?.text ? (
        <div className="text-center">
          <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
        </div>
      ) : (
        ""
      )}

      <button
        className="btn btn-primary saveButton mb-4"
        onClick={() => createBlog()}
      >
        {blog_page_labels?.blog_add_page_labels?.btn_label}
      </button>

      <div className="row">
        <div className="col-lg-8">
          <div className="card card-default">
            <div className="card-header card-header-border-bottom">
              <h2>{blog_page_labels?.blog_add_page_labels?.title}</h2>
            </div>
            <div className="card-body" style={{ overflow: "visible" }}>
              <div className="ec-store-uploads">
                <div className="form-group ">
                  <label className="form-label mandatory_field">
                    {blog_page_labels?.blog_add_and_edit_page_labels?.title}
                  </label>
                  <textarea
                    className="form-control"
                    name="title"
                    maxLength="200"
                    onChange={onChangeField}
                    value={formValues["title"] || ""}
                  />
                  <div className="errorMessage">
                    <Message
                      text={
                        errorMessages[
                          ErrorMessage({ fieldName: "title", errors })
                        ] ||  ErrorMessage({ fieldName: "title", errors })
                      }
                      type={"errorMsg"}
                      showMessage={showErrorMessage}
                    />
                  </div>
                </div>
                <div className="form-group ">
                  <label className="form-label mandatory_field">
                    {blog_page_labels?.blog_add_and_edit_page_labels
                      ?.sub_title || "Sub Title"}
                  </label>
                  <textarea
                    className="form-control"
                    name="sub_title"
                    maxLength="300"
                    onChange={onChangeField}
                    value={formValues["sub_title"] || ""}
                    placeholder="Enter sub title"
                  />
                  <div className="errorMessage">
                    <Message
                      text={
                        errorMessages[
                          ErrorMessage({ fieldName: "sub_title", errors })
                        ] ||  ErrorMessage({ fieldName: "sub_title", errors })
                      }
                      type={"errorMsg"}
                      showMessage={showErrorMessage}
                    />
                  </div>
                </div>
                <div className="form-group mb-3">
                  <label className="form-label mandatory_field">
                    {blog_page_labels?.blog_add_and_edit_page_labels?.content}
                  </label>
                  {contentBlocks.map((block, index) => (
                    <div
                      key={index}
                      className="content-block-content"
                      draggable
                      onDragStart={(e) => handleDragStart(e, index)}
                      onDragEnd={handleDragEnd}
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) => handleDrop(e, index)}
                      style={{ cursor: "move" }}
                    >
                      <div className="drag-handle">
                        <span className="mdi mdi-drag-horizontal"></span>
                      </div>
                      {block.type === "text" && (
                        <TextBlock
                          text={block.content}
                          autoFocus={focusBlockIndex === index}
                          onChangeText={(value) =>
                            updateContentBlock(index, value)
                          }
                          onRemove={() => {
                            removeContentBlock(index);
                          }}
                        />
                      )}

                      {block.type === "quote" && (
                        <QuoteBlock
                          quoteBlock={block.content}
                          autoFocus={focusBlockIndex === index}
                          onChangeText={(value) =>
                            updateContentBlock(index, value)
                          }
                          onRemove={() => {
                            removeContentBlock(index);
                          }}
                        />
                      )}

                      {block.type === "image" && (
                        <ImageBlock
                          blockImage={
                            typeof block.content === "object"
                              ? block.content
                              : null
                          }
                          onOpenBannerImageBlockSelector={(configData) => {
                            onOpenContentBlockImage(configData, index);
                          }}
                          onRemoveBlockImage={() =>
                            updateContentBlock(index, null)
                          }
                          onRemove={() => {
                            removeContentBlock(index);
                          }}
                        />
                      )}
                    </div>
                  ))}
                  <div className="errorMessage">
                    <Message
                      text={
                        errorMessages[
                          ErrorMessage({ fieldName: "content", errors })
                        ] || ErrorMessage({ fieldName: "content", errors })
                      }
                      type={"errorMsg"}
                      showMessage={showErrorMessage}
                    />
                  </div>
                  <div className="add-block-container">
                    {/* <button
                      className="add-block-btn"
                      onClick={() => setShowBlockOptions(!showBlockOptions)}
                    >
                      <span className="mdi mdi-plus-circle"></span>
                      Add Content Block
                    </button> */}
                    <button
                      type="button"
                      className="add-block-btn"
                      onClick={() => setShowBlockOptions(!showBlockOptions)}
                    >
                      <span className="mdi mdi-plus-circle"></span>
                      Add Content Block
                    </button>

                    {showBlockOptions && (
                      <div className="block-options">
                        <div className="block-options-header">
                          <h4>Choose Content Type</h4>
                        </div>
                        <div className="block-options-list">
                            <button
                              type="button"
                            className="block-option"
                            onClick={() => {
                              addContentBlock("text");
                              setShowBlockOptions(false);
                            }}
                          >
                            <span className="mdi mdi-text"></span>
                            <span>Text Block</span>
                          </button>
                          <button
                            type="button"
                            className="block-option"
                            onClick={() => {
                              addContentBlock("image");
                              setShowBlockOptions(false);
                            }}
                          >
                            <span className="mdi mdi-image"></span>
                            <span>Image Block</span>
                          </button>
                          <button
                            type="button"
                            className="block-option"
                            onClick={() => {
                              addContentBlock("quote");
                              setShowBlockOptions(false);
                            }}
                          >
                            <span className="mdi mdi-format-quote-open"></span>
                            <span>Quote Block</span>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="card card-default">
            <div className="card-header card-header-border-bottom">
              <h5>Blog Settings</h5>
            </div>
            <div className="card-body">
              <div className="form-group mb-3">
                <label className="form-label mandatory_field">
                  {blog_page_labels?.blog_add_and_edit_page_labels?.status}
                </label>
                <select
                  className="form-control"
                  name="status"
                  value={formValues["status"] || ""}
                  onChange={onChangeField}
                >
                  <option value="">Select Status</option>
                  {statusOptions &&
                    statusOptions?.map((optionString, index) => {
                      const [name, value] = optionString.split(",");
                      return (
                        <option value={name} key={index}>
                          {value}
                        </option>
                      );
                    })}
                </select>
                <div className="errorMessage">
                  <Message
                    text={
                      errorMessages[
                        ErrorMessage({ fieldName: "status", errors })
                      ] || ErrorMessage({ fieldName: "status", errors })
                    }
                    type={"errorMsg"}
                    showMessage={showErrorMessage}
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label className="form-label mandatory_field">
                  {blog_page_labels?.blog_add_and_edit_page_labels?.category}
                </label>
                <select
                  className="form-control"
                  name="blog_category_id"
                  value={formValues["blog_category_id"] || ""}
                  onChange={onChangeField}
                >
                  <option value="">Select Category</option>
                  {categories?.map((cat, index) => (
                    <option value={cat.blog_category_id || cat.id} key={index}>
                      {cat.name}
                    </option>
                  ))}
                </select>
                <div className="errorMessage">
                  <Message
                    text={
                      errorMessages[
                        ErrorMessage({ fieldName: "blog_category_id", errors })
                      ] || ErrorMessage({ fieldName: "blog_category_id", errors })  
                    }
                    type={"errorMsg"}
                    showMessage={showErrorMessage}
                  />
                </div>
              </div>
              <div className="form-group mb-3">
                <label className="form-label">Featured Image</label>
                <BlogImagesPreview
                  acceptMultipleFiles={false}
                  featuredImage={false}
                  userProfile={false}
                  onOpen={onOpenFeaturedImage}
                  selectedImageInfo={selectedImages}
                  onRemoveImageIds={onRemoveImageIds}
                  deleteDisable={true}
                  savedImages={selectedImages?.blog_image_id ? [selectedImages]:[]}
                />
                <div className="errorMessage mt-3">
                  <Message
                    text={
                      errorMessages[
                        ErrorMessage({ fieldName: "featured_image", errors })
                      ] || ErrorMessage({ fieldName: "featured_image", errors })
                    }
                    type={"errorMsg"}
                    showMessage={showErrorMessage}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BlogImageSelector
        Config={config}
        onClose={onClose}
        onSelectImageInfo={onSelectImages}
      />
      <div className=" mt-4">
        <button className="btn btn-primary" onClick={() => createBlog()}>
          {blog_page_labels?.blog_add_page_labels?.btn_label}
        </button>
      </div>
    </React.Fragment>
  );
}
